const moment = require('moment');
const utils = require('../../../lib/utils');

/*

	### instructions to use this component ###

	add package.json-dependency
		"air-datepicker": "^2.2.3"


	add these lines in client.js of project
		require('./node_modules/air-datepicker/dist/css/datepicker.min.css');
		require('./node_modules/air-datepicker/dist/js/datepicker.min.js');
		require('./node_modules/air-datepicker/dist/js/i18n/datepicker.de.js');
*/
module.exports = {
	config: {
		momentDataDateFormat: '',
		momentDateFormat: 'DD.MM.YYYY',
		airDatePicker: {
			language: 'de',
			dateFormat: 'dd.mm.yyyy',
			inline: false,
			autoClose: true,
			// view: 'days', // days, months, years
			// minView: 'days', // days, months, years
			onSelect: function(formattedDate, date, inst) {
				var self;
				if((self = getComponent(inst.$el.closest('[data-component-index]')))){
					self.fieldToModel(date);
				}
			},
			onShow: function(inst, animationCompleted){
				var self;
				if(animationCompleted && (self = getComponent(inst.$el.closest('[data-component-index]')))){
					self.model.visible = true;
				}
			},
			onHide: function(inst, animationCompleted){
				var self;
				if(animationCompleted && (self = getComponent(inst.$el.closest('[data-component-index]')))){
					self.model.visible = false;
				}
			}
		}
	},

	model: {
		visible: false,
		titleKey: ''
	},

	events: {
		// change all necessary values in case of changing the textboxes' date-value manually
		textChange: {
			type: 'change',
			selector: 'input',
			action: function(event){
				event.stopImmediatePropagation();
				
				var self = event.data.component;
				var $input, value;
				if(
					($input = $(event.target)).length > 0 &&
					($input = $input.closest('input')).length > 0
				){
					value = self.getDataValue($input.val(), true);

					// set the date and select it
					if(value === false){
						// NOTE: may be here should be triggered some onInvalidDate on closest elements so the form may handle such errors.
						// NOTE: may be here an error should be thrown. depends on error handling.
						console.error('AirDateTimePicker: invalid date got @ "' + ((self.model || {}).fieldCode || '') + '": ' + $input.val());
					} else if(value === null){
						self.model.dp.date = value;
					} else {
						self.model.dp.date = new Date(value);
						self.model.dp.selectDate(new Date(value));
					}
				}
			}
		},

		// open date-picker on click on icon
		toggle: {
			type: 'click',
			selector: '.datepicker-action-icon',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component
				if(!((self.formMapping || {}).fieldConfig || {}).disabled && !(self.model.config || {}).disabled){
					self.toggleCalendar();
				}
			}
		}
	},

	methods: {
		/**
		 * this function returns the date in the wanted format used for backend. (this.config.momentDataDateFormat || ISO)
		 * invalid dates drives this function to return false. empty ones return null.
		 *
		 * @param date			Date || String || Moment || null || '' || false - wanted date
		 * @param returnISO		boolean - if this parameter is set to true the this.config.momentDataDateFormat flag will be ignored and the iso format will be returned instead.
		 * @returns false || null || String
		 */
		getDataValue: function(date, returnISO){
			var m;
			if(date instanceof Date || !utils.isEmpty(date)){
				if(typeof date === 'string') {
					// prevent deprecation warning (moment reads the date according to the view-format)
					m = moment(date, this.config.momentDateFormat);
				} else {
					m = moment(date);
				}

				if(!m.isValid()) return false;
			}
			else {
				date = null;
			}

			if(m){
				this.updateTitle(m.format(this.config.momentDateFormat));
				if(this.config.momentDataDateFormat && !returnISO)	date = m.format(this.config.momentDataDateFormat);
				else 												date = m.format();
			}

			return date;
		},

		updateTitle: function(date){
			if(this.$){
				if(date){
					if(this.model.titleKey){
						this.$.attr('title', __(this.model.titleKey, { ts: date }));
					} else {
						this.$.attr('title', date || '');
					}
				} else {
					this.$.removeAttr('title');
				}
			}
		},

		setDate: function(date){
			if(date === null){
				this.model.dp.clear();
			} else {
				var m = moment(date)
				date = m.format();

				// set the date and select it
				this.updateTitle(m.format(this.config.momentDateFormat));
				this.model.dataDATE = date;
				this.model.dp.date = new Date(date);
				this.model.dp.selectDate(new Date(date));
			}
		},

		/**
		 * tell the closest form that this form-field has been changed.
		 *
		 * @param date Date || String || Moment || false || null || ''
		 */
		fieldToModel: function(date){
			var self = this;

			date = this.getDataValue(date);
			if(
				date !== false
				&&
				(this.model.dataDATE || date)
				&&
				(
					(!this.model.dataDATE && date)
					||
					(this.model.dataDATE && !date)
					||
					(this.config.momentDataDateFormat && moment(this.model.dataDATE, this.config.momentDataDateFormat).diff(moment(date, this.config.momentDataDateFormat)) !== 0)
					||
					(!this.config.momentDataDateFormat && moment(this.model.dataDATE).diff(moment(date)) !== 0)
				)
			){
				this.model.dataDATE = date;
				// update date
				self.triggerClosest('onChildChanged', {
					fieldCode: self.model.fieldCode,
					value: date
				});
			}
		},

		/**
		 * this function is used to show or hide the calendar according to if its visible or not.
		 */
		toggleCalendar: function(){
			if(this.model.visible) 	this.model.dp.hide();
			else 					this.model.dp.show();
		},

		onBeforeAttach: function(){
			// NOTE: overwrite this method if necessary
		}
	},

	hooks: {
		attach: function($element, options){
			if(options.refresh) return;

			// merge config given by template-atom-config into real config
			utils.refMerge(this.config, this.model.config);
			var config = this.config.airDatePicker;

			this.onBeforeAttach();

			// estimate init date
			var actualDate = null;
			if(this.model.dataDATE !== undefined){
				if(this.model.dataDATE !== null) actualDate = moment(this.model.dataDATE);
			}
			else if(this.config.initDate){
				if(this.config.initDate === 'now') 			actualDate = moment();
				else 										actualDate = moment(this.config.initDate);
				if(this.config.initDateStartOf) 			actualDate = actualDate.startOf(this.config.initDateStartOf)
				else if(this.config.initDateEndOf) 			actualDate = actualDate.endOf(this.config.initDateEndOf)

				if(this.config.initDateModification){
					var d;
					for (d in this.config.initDateModification.diff || {}){
						actualDate = actualDate.add(this.config.initDateModification.diff[d], d);
					}
				}
			}

			if(this.config.minDate){
				var minDate;
				if(actualDate) 	minDate = actualDate.clone();
				else 			minDate = moment();

				if(this.config.minDate.startOf){
					minDate = minDate.startOf(this.config.minDate.startOf);
				}
				if(this.config.minDate.endOf){
					minDate = minDate.endOf(this.config.minDate.endOf);
				}
				config.minDate = minDate.toDate();
			}
			if(this.config.maxDate){
				var maxDate;
				if(actualDate) 	maxDate = actualDate.clone();
				else 			maxDate = moment();

				if(this.config.maxDate.startOf){
					maxDate = maxDate.startOf(this.config.maxDate.startOf);
				}
				if(this.config.maxDate.endOf){
					maxDate = maxDate.endOf(this.config.maxDate.endOf);
				}
				config.maxDate = maxDate.toDate();
			}

			// init
			var fieldDefaultValue = '';
			var inputElement = $element.find('input');

			// NOTE: it is mandatory to provide the defaultDate config parameter as moment-instance in case of format and or locale usage.
			if(actualDate && actualDate !== null){
				// add start-date to config
				config.startDate = new Date(actualDate.format());
				// set field-value
				fieldDefaultValue = actualDate.format(this.config.momentDateFormat);
			}

			// set value to input field and prepare air-picker
			inputElement.val(fieldDefaultValue).datepicker(config);
			this.model.dp = inputElement.data('datepicker');

			// if a start date is given
			if(actualDate && actualDate !== null){

				// set the date and select it
				this.updateTitle(fieldDefaultValue);
				this.model.dp.date = new Date(actualDate.format());
				this.model.dp.selectDate(new Date(actualDate.format()));
			}
		}
	}
};